import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const PhoneAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4 13C19.2 13 19 12.9 18.7 12.9C18.3 12.8 17.8 12.7 17.4 12.5C16.4 12.2 15.4 12.6 14.9 13.5L14.7 14C12.7 12.9 11.1 11.3 9.99999 9.3L10.5 9C11.4 8.6 11.9 7.5 11.5 6.5C11.3 6.1 11.2 5.6 11.1 5.2C11.1 5 11 4.8 11 4.5C10.8 3.1 9.49999 2 7.99999 2H4.99999C4.09999 2 3.29999 2.4 2.79999 3C2.19999 3.7 1.99999 4.6 2.09999 5.5C2.59999 9.7 4.49999 13.5 7.49999 16.5C10.5 19.5 14.4 21.4 18.5 21.9C19.4 22 20.2 21.7 20.9 21.2C21.5 20.6 21.9 19.8 21.9 19V16C21.9 14.4 20.9 13.2 19.4 13Z"
      fill="currentColor"
    />
  </svg>
)

export default PhoneAlt
